// Add space to the card itself so pictures and QR codes retain their size.
export function standardCardLayout({ photoUrl, picturePosition, qrUrl, qrPlacement }) {
  const photo = Boolean(photoUrl) && (picturePosition || 'above-name') === 'above-name';
  const qr = Boolean(qrUrl) && qrPlacement === 'below-title';
  return photo ? (qr ? 'photo-qr' : 'photo') : (qr ? 'qr' : 'card');
}
export function cardLayoutMetrics(layout = 'card') {
  const photoPadding = layout === 'photo' || layout === 'photo-qr' ? 60 : 0;
  const qrSpace = layout === 'qr' || layout === 'photo-qr' ? 330 : 0;
  const textureHeight = 1135 + photoPadding + qrSpace;
  const height = .12 + 3.13 * textureHeight / 1135;
  return { photoPadding, qrSpace, textureHeight, height, aspectRatio: 1.15 * 3.25 / height };
}
